<template>
  <transition name="fade">
    <div class="mod-req-app-100">
      <div class="mod-req-app-container">
        <div class="title-wrapper">
          <div class="title-big title-color__red">
            DELETE VENDOR
          </div>
        </div>
        <div>
          <div>Nama Vendor</div>
          <input type="text" class="input-100" v-model="get_nama" disabled />
        </div>
        <div>
          <div>Note</div>
          <input type="text" class="input-100" v-model="reviewNote" />
        </div>
      </div>
      <div class="multy-btn-center">
        <div class="flex-space-around">
          <div class="btn-small">
            <div class="btn-wrapper btn-wrapper__red" @click="deleteVendor()">
              Delete
            </div>
          </div>
          <div class="btn-small">
            <div class="btn-wrapper btn-wrapper__red" @click="closeModal()">
              Cancel
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  data() {
    return {
      reviewNote: '',
      nama_vendor: '',
    }
  },
  created() {
    this.$store.dispatch('myRequest/sapDetail', this.$route.params.id)
  },
  computed: {
    get_nama() {
      return this.$store.state.myRequest.nama_vendor
    },
  },
  methods: {
    deleteVendor() {
      this.$store.dispatch('myRequest/deleteVendor', {
        id: this.$store.state.myRequest.choosedVendor,
        note: this.reviewNote,
      })
    },
    closeModal() {
      this.$store.commit('myRequest/CANCEL_EXTEND')
      this.$store.commit('modalReqApp/SET_VALUE', {
        name: 'modalDeleteVendor',
        value: false,
      })
    },
  },
}
</script>
